module.exports = __webpack_public_path__ + "img/pocket-16_jp.c164c33.jpg";